<template>
    <div class="product-list" >
        <searchtop  ref="search" @doSearch="doSearch" />
        <div class="filterbar">
            <ul :class="filtersort?'show':''">
                <li :class="filterindex==0?'selected':''" v-on:click="onFilterBar(0)"><span>{{filterindex==11?'价格最低':(filterindex==12?'价格最高':'综合')}}</span><van-icon name="arrow" class="down" /></li>
                <li :class="filterindex==1?'selected':''" v-on:click="onFilterBar(1)"><span>销量</span></li>
                <li :class="filterindex==2?'selected':''" v-on:click="onFilterBar(2)"><span>上新</span></li>
                <!-- <li :class="filterindex==3?'selected':''" v-on:click="onFilterBar(3)"><span>筛选</span></li> -->
            </ul>
            <div :class="'item_options '+(filtersort?'show':'')">
                <ul>
                    <li :class="filterindex==10?'selected':''" v-on:click="onFilterBar(10)">综合</li>
                    <li :class="filterindex==11?'selected':''"  v-on:click="onFilterBar(11)">价格最低</li>
                    <li :class="filterindex==12?'selected':''" v-on:click="onFilterBar(12)">价格最高</li>
                </ul>
            </div>
        </div>
         
        <div class="main-list" :style="{'background-color':$abctheme.basecolor}" ref="wrapper">
           <van-list
                    v-model="queryparams.loaded"
                    :finished="queryparams.loadingType=='nomore'?true:false"
                    :finished-text="queryparams.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                    @load="loaddata"
                    >
                     <div class="myinfot"   v-for="(product,i) in products" :key="i" @click.stop="godetail(product)" >
                                        <div class="myinfot-pic">
                                            <img :src="$baseurl+product.productImageUrl">
                                        </div>
                                        <div class="myinfot-dd">
                                            <div class="myinfot-info">
                                                <div class="myinfot-info-tit">{{product.title}}</div>
                                                <div v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor}">
                                                    【海外产品】
                                                </div>
                                                <div class="myinfot-info-cm">{{product.skus.length>1?'多':'单'}}尺码可选</div>
                                                <div class="myinfot-footer">
                                                    <span class="myinfot-price">{{product.price}}</span> 
                                                    <!-- <span class="myinfot-smtt">{{product.rSaleNum}}人付款</span> -->
                                                    <van-icon class="myinfot-iicart" :size="28" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="ai66" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                </van-list>
        </div>
    </div>
</template>

<script>
import searchtop from "../../components/search/searchtop";

export default {
  components: {
    searchtop
  },
  data() {
    return {
      queryparams:{
          loaded:false,
          loadingType: 'more',
          name: "",
          sku:"",
          ProductType:undefined,
          productSku: "",
          sorting: "",
          maxResultCount: 10,
          skipCount: 0,
          filterindex:0,
          categoryId:0,
          isIntegral:false
      },
      refreshing:false,
      products:[],
      value: "",
      filterindex: 0,
      filtersort: false,
      filtershow: false,
      scroll:0
    };
  },
  beforeRouteLeave(to, form, next){

       if(to.meta.title!='商品详情'){
        form.meta.keepAlive=false;
    }else{
        form.meta.keepAlive=true;
    }
      this.scroll=this.$refs.wrapper.scrollTop;
      next();
  },
  beforeRouteEnter(to, form,next){
 
    console.log('beforeRouteEnter',arguments);
     next();
      
  },
  activated() {
 
	this.$refs.wrapper.scrollTop = this.scroll
},
  created(){
     this.init();
  },
  methods: {
    init(){
       var params= this.$route.query;
      if(params.name)
      {
          this.queryparams.name=params.name;
          //设置头部搜索值为对应值
      }
      if(params.categoryId){
        this.queryparams.categoryId=params.categoryId;
      }
      this.$nextTick(()=>
      {
          this.$refs.search.value=this.queryparams.name;
      })
      this.loaddata();
    },
    onFilterBar(value) {
      if (value == 0) {
        this.filtersort = !this.filtersort;
      }
      else if (value == 3) { //弹出各种选项可以用来放分类
        this.filtershow = !this.filtershow;
      } 
      else {
        this.filtersort = false;
        this.filterindex = value;
        if(this.filterindex==10)
        {
            //综合已排序和ID为准
            this.queryparams.sorting="";
        }
        if(this.filterindex==11) //价格最小
        {
             this.queryparams.sorting=" UserPrice asc,id desc";
        }
        if(this.filterindex==12) //价格最大
        {
          this.queryparams.sorting=" UserPrice desc,id desc"; 
        }
        if(this.filterindex==1) //销量
        {
          this.queryparams.sorting="  BaseSaleNum+RealSaleNum desc,id desc"; 
        }
        if(this.filterindex==2) //新品
        {
          this.queryparams.sorting="  creationTime desc";
            // this.$toast.success({message:'暂未实现'});
            // return ;
        //   this.queryparams.sorting="  BaseSaleNum+RealSaleNum desc,id desc"; 
        }
        this.loaddata('refresh');
      }
    },
    showProduct(product){
        this.$router.push('/product/'+product.id);
    },
    onRefresh()
    {
        this.loaddata('refresh');
    },
    loaddata(source)
    {
        if (this.queryparams.loadingType === 'loading' || this.queryparams.loadingType === 'nomore') {
            //防止重复加载
            if(source != 'refresh')
            {
                return;
            } 
        }
        if (source == 'refresh') {
            this.products = [];
            this.queryparams.skipCount = 0;
        }
        this.queryparams.loadingType = 'loading';
        //加载数据
        this.ajax.post('/api/services/app/PhoneCom/QueryProductList', this.queryparams).then(x => {
            this.queryparams.skipCount += this.queryparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.products = this.products.concat(x.result.items);
            console.log(this.products);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.queryparams.loadingType = totalcount > (this.queryparams.skipCount) ? 'more' :'nomore';
        }).finally(()=>
        {
                this.queryparams.loaded=false;
                this.refreshing=false;
        });
    },
    clearname()
    {
      this.queryparams.name='';
    },
    doSearch(name)
    {
        this.queryparams.name=name;
        this.loaddata('refresh');
    },
    navtodetail(item)
    {
          //console.log(this.$router);
          var productsku=item.productSku;
          this.$router.push({path:'/product/'+productsku});
    },
    godetail(item)
    {
        
        var productsku=item.productSku;
        this.$router.push({path:'/product/'+productsku});
    }
  }
};
</script>

<style lang="scss" scoped>
.main-list{
position: absolute;
padding: 2%;
    width: 96%;
    top: 80px;
    left: 0;
    bottom: 0;
    background: #fff200;
    overflow-x: hidden;
}
.main-list-product{
    margin-bottom: 10px;
    padding: 2px;
}
</style>

<style lang="scss" scoped>
.product-list{
      background: #fff200;
    .additional .price{
        position: absolute;
        bottom: 6px;
        height: 34px;
    }
}
.filterbar {
  font-size: 14px;
  position: relative;
  background-color: #fff;
  ul {
    width: 100%;
    height: 40px;
  }
  li {
    color: #999;
    width: 33.33%;
    float: left;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #eee;
    i {
      font-size: 12px;
      margin-left: 2px;
    }
    .down {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
    }
  }
  .selected {
    color: #e93b3d;
  }
  .show {
    .down {
      -webkit-transform: rotate(-90deg);
      transform: rotate(-90deg);
    }
  }
  .item_options {
    width: 100%;
    position: absolute;
    top: 41px;
    background: #fff;
    display: none;
    z-index: 1;
    li {
      width: 100%;
      text-align: left;
      padding-left: 10px;
    }
  }

  .item_options.show {
    display: block;
  }
  .filterlayer {
    width: 85%;
    height: 100%;
    background-color: #f7f7f7;
    &_bottom {
      &_buttons {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        z-index: 10;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        .cancel {
          color: #333;
          background-color: #fff;
          box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.07);
        }
        .confirm {
          color: #fff;
          background-color: #e93b3d;
        }
      }
      &_button {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        font-size: 16px;
        height: 49px;
        line-height: 49px;
        text-align: center;
      }
    }
    ul {
      height: auto;
      background: #fff;
      margin-bottom: 15px;
    }
    li {
      width: 100%;
      text-align: left;
        height: auto;
        line-height: initial;
      .van-cell{
        font-size: 16px;
      }
      .big {
        height: 25px;
        max-width: 250px;
        overflow: hidden;
        font-size: 16px;
        color: #333;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }
    .filterInner{
        overflow-y: scroll;
        max-height: 100%;
        .van-button{
            height: 40px;
            margin-bottom: 15px;
            line-height: 40px;
        }
    }
    .tags_selection {
      font-size: 14px;
      text-align: center;
      background-color: #fff;
      position: relative;
      margin: 0;
      padding: 10px 0 0 10px;
      .option {
        box-sizing: border-box;
        float: left;
        width: 33.33%;
        padding-right: 10px;
        height: 30px;
        line-height: 30px;
        margin-bottom: 10px;
        a {
          position: relative;
          display: block;
          padding: 0 5px;
          color: #666;
          background-color: #f7f7f7;
          border-radius: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
            height: 30px;
        }
      }
    }
  }
}
.order-item{
    font-size: 12px;
    margin: 10px 10px 10px 10px;
    box-shadow: 1px 1px 4px #d0d0d0;
}
.van-pull-refresh{
    overflow: auto;
}
.van-hairline--top-bottom{
    border-radius: 8px;
    padding: 4px;
}




.myinfot{
    background-color:white;
    padding:5px;
    border-radius:4px;
    display: inline-block;
    width: 46%;
    margin-bottom: 10px;
    height: 250px;
    font-size: 0.3rem;
}
.myinfot:nth-child(even){
    float: right;
}
.myinfot-pic{
    width: 100%;
}
.myinfot-pic img{
    width: 100%;
}
.myinfot-dd{
    margin-top: 5px;
    padding-left:10px;
}
.myinfot-info{
   min-height: 80px;
   position: relative;
}
.myinfot-info-tit{
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
   word-break: break-all;
   overflow: hidden;
}
.myinfot-info-cm{
    font-size: 10px;
    color:#9b6933;
}
.myinfot-smtt{
     font-size: 10px;
    margin-left: 5px;
}
.myinfot-footer{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
.myinfot-price::before{
    content: "￥";
    position: absolute;
    left: -7px;
}
.myinfot-price{
    margin-right: 10px;
    font-size: 18px;
    color: red;
    padding-left: 7px;
}
.myinfot-iicart{
    position: absolute;
    right: 0;
    bottom: -5px;
}
</style>